import { ExternalCompanyIdEnum } from '@/shared/constants/external-company-id.enum';
import { IAgentDetailsProps } from '@/shared/models/orders/single-order-with-details.model';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import type { FC, JSX } from 'react';

const AgentDetailsCard: FC<IAgentDetailsProps> = (props: IAgentDetailsProps): JSX.Element => {
  return (
    <Grid item container display={'flex'} height={'100%'} justifyContent={'start'}>
      <Grid
        item
        p={1}
        xs={5}
        md={12}
        color={`${props.companyExternalId == ExternalCompanyIdEnum.EMERA_EIE ? ' #290F12' : '#fff'}`}
        textAlign={'right'}
        sx={{ height: { md: `${props.companyExternalId == ExternalCompanyIdEnum.EMERA_EIE ? '25%' : '40%'}` } }}>
        <Typography
          fontWeight={100}
          color={`${props.companyExternalId == ExternalCompanyIdEnum.EMERA_EIE ? ' #290F12' : '#fff'}`}
          variant="h5">
          {props.agentTitle}
        </Typography>
        <Typography fontWeight={500} variant={'h2'}>
          {props.agentName + ' ' + props.agentLastName}
        </Typography>
        <Typography fontWeight={100} variant={'h4'}>
          {props.agentOfficeName}
        </Typography>
        <Typography fontWeight={100} variant={'h5'}>
          {props.agentEmail}
        </Typography>
        <Typography fontWeight={100} variant={'h5'}>
          {props.agentPhone}
        </Typography>
      </Grid>
      {props.companyExternalId == ExternalCompanyIdEnum.EMERA_EIE &&
      <Grid item xs={2} md={'auto'} sx={{ backgroundColor: '#290F12', padding: '10px 12px' }}>
        <img
          style={{ width: '49px', height: '50px' }}
          src="/images/emera/emera_hovedlogo_beige.svg"
          alt="logo"
          className=""
        />
      </Grid>}
      <Grid
        item
        xs={5}
        md={12}
        sx={{
          height: { md: '60%' },
          backgroundImage: `url(${props.agentImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top 10% right 0%',
        }}></Grid>
    </Grid>
  );
};

export default AgentDetailsCard;
